<script setup lang="ts">
import { Header } from '@/components/ui';
import { Footer } from '@/components/ui';
import { convertUrl } from '@/utils/convertUrl';

const D_CARD_CASHING =
  'ｄカードのキャッシングをご利用中のお客さまへの注意事項は<a class="arrow_icon arrow_icon02" href="/apply/#anc_02">こちら</a>';
</script>

<template>
  <Header />
  <div class="isp hbg_bg"></div>

  <nav class="breadcrumb">
    <div class="breadcrumb_inr">
      <ol class="breadcrumb_list" itemscope itemtype="https://schema.org/BreadcrumbList">
        <li class="breadcrumb_item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a itemprop="item" href="/"><span itemprop="name">トップ</span></a>
          <meta itemprop="position" content="1" />
        </li>
        <span>&nbsp;</span>
        <li class="breadcrumb_item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a itemprop="item" href="/inquiry/"><span itemprop="name">お問い合わせ</span></a>
          <meta itemprop="position" content="2" />
        </li>
        <span>&nbsp;</span>
        <li class="breadcrumb_item" itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <span itemprop="name">dスマホローンチャットサービスについて </span>
          <meta itemprop="position" content="3" />
        </li>
      </ol>
    </div>
  </nav>
  <!-- /.breadcrumb -->

  <main class="main">
    <section class="section01">
      <div class="section_inr01">
        <h1 class="title_lv1">dスマホローンチャットサービスについて</h1>
      </div>
    </section>
    <section class="section02">
      <div class="bgRed">
        <div class="section_inr01">
          <h2 class="title_lv2">チャットの操作について</h2>
          <div class="tAc">
            <img src="/img/chatsetumei.png" alt="チャットの操作について" width="542" />
          </div>
          <ul class="listType01">
            <li>画像や動画の送信はできません。</li>
            <li>&lt;&gt;&¥”’など一部利用できない文字があります。</li>
          </ul>
        </div>
      </div>
      <section class="section02 bgBule">
        <div class="section_inr01">
          <h2 class="title_lv2">運営について</h2>
          <ol class="listType07">
            <li>
              チャット自動応答は年中無休です。なお、システムメンテナンスにより、運営時間が変更になる場合があります。
            </li>
            <li>
              お客さまのご質問が解決しない場合は、dスマホローンセンター
              お問い合わせ・お客さま相談ダイヤル(0120-818-360)にお問い合わせください。<br />お客さま相談ダイヤルの運営時間は年末年始を除く10:00～18:00です。<br />なお、年末年始期間やシステムメンテナンス期間により、運営時間が変更になる場合があります。<br />また、お問い合わせが集中している場合など、お電話がつながりにくい場合があります。
            </li>
          </ol>
        </div>
      </section>
    </section>
    <section class="section03">
      <div class="section_inr01">
        <h2 class="title_lv2">サポート範囲</h2>
        <ol class="listType07">
          <li>dスマホローンに関するお問い合わせにお答えします。</li>
          <li>
            個人を特定したお問い合わせや、各種サービスのお申込みなどのお手続きについては、直接受付することはできません。
          </li>
          <li>画像や動画の送信はできません。</li>
          <li>
            日本語のみ対応しております。<br />We can speak Japanese only, sorry. Foreign language call number
            0120-005-250
          </li>
          <li>過去のサポート履歴に関するお問い合わせには一切応対しかねますので、あらかじめご了承ください。</li>
          <li>オペレーターによるチャットサポートは実施しておりません。（チャット自動応答のみになります）</li>
        </ol>
      </div>
    </section>
    <section class="section04 bgBule">
      <div class="section_inr01">
        <h2 class="title_lv2">注意事項</h2>
        <ol class="listType07">
          <li>
            お名前、お電話番号、ご住所などの個人情報を記載してのお問い合わせはご遠慮ください。<br />お客さま情報保護の観点から、お客さまの契約状況を特定したご質問に回答はできかねますので、あらかじめご了承ください。
          </li>
          <li>チャットでのお問い合わせ中に他のページを開いた場合、チャットの接続が切断される場合があります。</li>
          <li>本サービスの内容は、予告なく変更する場合がございます。</li>
          <li>
            一度チャットによるお問い合わせ画面が表示された操作と同様の操作を行っていただいた場合でも、チャットによるお問い合わせ開始の画面が表示されない場合があります。
          </li>
        </ol>
      </div>
    </section>
    <section class="section05">
      <div class="section_inr01">
        <h2 class="title_lv2">ご利用環境</h2>
        <ol class="listType07">
          <li>
            より安全かつ快適にご利用いただくため、最新バージョンの推奨OS・ブラウザでのご利用をお願いします。<br />推奨環境以外からの接続時はご利用出来ない可能性や、動作や表示が正しく行われない可能性があります。
          </li>
          <li>お客さまの利用環境や通信が不安定な状態となった際に、チャットの接続が切断される場合があります。</li>
        </ol>
      </div>
    </section>

    <section class="section06 bgBule">
      <div class="section_inr02">
        <div class="relInfo">
          <h2 class="relInfo_title">関連情報：お問い合わせ</h2>
          <div class="relInfo_cont">
            <p class="relInfo_lead">
              <a href="/inquiry/"><span class="arrow_icon">お問い合わせについて</span></a>
            </p>
            <ul class="relInfo_list">
              <li><span class="relInfo_current">dスマホローンチャットサービスについて</span></li>
            </ul>
          </div>
        </div>
        <!-- /.relInfo -->
      </div>
    </section>
  </main>
  <!-- /.main -->

  <section class="section02">
    <!--#include virtual="/focus/ssi/cv_area.html" -->
    <ul class="cv_card cv_btnArea">
      <li class="cv_card_item">
        <h2 class="title_lv2">新規お申込み</h2>
        <div class="cv_card_text_area">
          <p class="cv_card_text pctAl sptAc">
            <span class="ask"><span class="emphasis">お申込み</span>から<span class="emphasis">ご契約</span>まで</span
            ><span class="ask"><span class="emphasis">スマホ<span>で</span>完結！</span></span>
          </p>
        </div>
        <div class="cv_card_btn01">
          <p class="top_btnItem btnType02 btn_icon btn_icon01 cv_card_btn fwb">
            <a
              :href="`${convertUrl()}common/login/cushionWithUniversalLinkActivation?prompt=relogin&transitionSourceId=basic`"
              >今すぐお申込み<br /><span>（dアカウントでログイン）</span></a
            >
          </p>
          <ul class="listType01 tAl mt10">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <li v-html="D_CARD_CASHING"></li>
          </ul>
        </div>
      </li>
      <li class="cv_card_item">
        <h2 class="title_lv2">簡易シミュレーション</h2>
        <div class="cv_card_btn02">
          <p class="top_btnItem btnType03 btn_icon btn_icon04 cv_card_btn fwb">
            <a href="/apply/1second/"><span>お借入可能？優遇金利は何％？</span>簡単1秒診断</a>
          </p>
        </div>
        <div class="cv_card_btn02 mt10">
          <p class="top_btnItem btnType03 btn_icon btn_icon02 cv_card_btn fwb">
            <a href="/borrow/simulation/"
              ><span>毎月のご返済額はいくらぐらい？</span
              ><span class="fs18"><span class="ask">ご返済</span><span class="ask">シミュレーション</span></span></a
            >
          </p>
        </div>
      </li>
    </ul>
  </section>
  <!-- /.section02 -->
  <Footer />
</template>
